export const MAX_PRICE = 999;
export const MIN_PRICE = 1;
export const PRICE_INFINITY_HIGH = 1000;
export const PRICE_INFINITY_LOW = 0;
